export function isProduction() {
    const host = window.location.hostname;
    return host === 'cashmate.my' || host === 'www.cashmate.my' || host === 'cashmate-v1.web.app' || host === 'cashmate-v1.firebaseapp.com';
  }